import { h, Component } from 'preact';
import { BaseComponent } from "../../common/BaseComponent";
import { IDocViewerProps, IDocViewerState } from './IDocViewer'
import { bind } from 'decko';

import LinearProgress from 'preact-material-components/LinearProgress';
import { IModalDialogState } from '../modalDialog/IModalDialog';

export class DocViewer extends BaseComponent<IDocViewerProps, IDocViewerState> {

    constructor(props, ctx) {
        super(props, ctx);
        this.init(props);
    }

    public init(props) {
        //this.setState({
        //    //url: `/assets/ViewerJs/#${window.location.origin}/api/building/getFile/${encodeURIComponent(props.url)}`
        //    //url: ''
        //    //url: `https://docs.google.com/viewer?url=${props.url}&embedded=true`
        //    url: `/assets/pdf/web/viewer.html?file=${encodeURIComponent(window.location.origin +"/api/building/getFile?url="+encodeURIComponent(props.url))}`
        //});

        this.modal.showLoader(this.loadDoc(props.url)).then((url) => {
            this.setState({
                url: `/assets/pdf/web/viewer.html?file=${encodeURIComponent(url)}`
            });
        }).catch((e) => {
            this.modal.alert(e.errorMessage || e);
        });
    }

    public loadDoc(url):Promise<string> {
        var p = new Promise<string>((res, rej) => {
            fetch(`/api/building/getFile?url=${url}`, {
                method: 'GET'
            }).then((response) => {
                if (response.status >= 200 && response.status < 300) {

                    response.blob().then((blob) => {
                        var burl = (window as any).URL.createObjectURL(blob);
                        res(burl);
                    }).catch(e => rej(e));
                }
                else {
                    rej(response.statusText);
                }
            }).catch(e=>rej(e));            
        });
        return p;
    }

	@bind
    public onDocumentLoad({ numPages }) {
        this.setState({ numPages, pageNumber:1 });
    }

    @bind
    public destroy() {
        (window as any).URL.revokeObjectURL(this.state.url);
        this.setState({ url:"" });
    }

    componentWillReceiveProps(props) {
        if (props.url != this.props.url)
            this.init(props); 
    }
     
    render() {
        if (this.state.url)
            return h("iframe", { src: this.state.url, style: "width:100%; height:100%; border:none;", allowfullscreen: true, webkitallowfullscreen: true } as any); // <iframe src={this.state.url} style="width:100%; height:100%; border:none;" allowfullscreen webkitallowfullscreen ></iframe>;
        else
            return <div></div>;//<div style="padding:20px; display:flex; align-items:center; height:100%;"><div style=" width:100%;"><h2 class="mdc-dialog__header__title">Please wait...</h2><br/><LinearProgress indeterminate={true} /></div></div>;
    }

}



// WEBPACK FOOTER //
// ./components/docViewer/docViewer.tsx